/**
 * ParkSelector — dropdown for park selection (Plan Visit page).
 *
 * Wraps InlineDropdown with the park emoji map so pages don't repeat data.
 * Receives the parks array as a prop to avoid duplicating the useParks fetch.
 */
import React from 'react';
import { InlineDropdown } from './InlineDropdown';
import { getParkIcon } from '../../config/parkIcons';

export function ParkSelector({
  parks,
  value,
  onChange,
  placeholder = 'Select a park...',
  className = '',
  includeAll = false,
  allLabel = 'All parks',
}: {
  parks: { name: string; id: string }[];
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  includeAll?: boolean;
  allLabel?: string;
}) {
  const options = React.useMemo(() => {
    const parkOptions = parks.map((p) => {
      const Icon = getParkIcon(p.name);
      return { value: p.name, label: p.name, icon: <Icon className="w-4 h-4" /> };
    });
    return includeAll ? [{ value: '', label: allLabel, icon: undefined }, ...parkOptions] : parkOptions;
  }, [parks, includeAll, allLabel]);

  return <InlineDropdown value={value} options={options} onChange={onChange} placeholder={placeholder} className={className} />;
}
